export enum TrackVectorLayerType {
    Track, Dots, Trackpoints
}